import React from 'react';
import { createUseStyles } from 'react-jss';
import { isMobile } from 'react-device-detect';
import { eventTypes, UserType } from '../notificationConstants';
import { useTranslation } from 'react-i18next';
import { TimeAndBadgeComponent } from './common';

const useStyle = createUseStyles({
    notificationBodyTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    headerTextStyle: {
        color: '#111',
        fontSize: '12px',
        fontWeight: 600,
    },
    userName: {
        color: '#666',
        textAlign: 'right',
        fontSize: '12px',
        fontWeight: 400,
    },
});

interface CreateHeaderProps {
    item: string;
    entityIdPrettyName?: string;
    classes: Record<string, string>;
    // eslint-disable-next-line react/no-unused-prop-types
    sourceName: string;
}

const CreateHeaderForNotificationBody = (props: CreateHeaderProps) => {
    const { t } = useTranslation();
    const { item, entityIdPrettyName, classes } = props;

    switch (item) {
        case 'issue_comment':
            return (
                <span>
                    <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
                        {' '}
                        {t('added a')}
                        {' '}
                    </span>
                    <span className={classes.headerTextStyle}>
                        {t('Comment')}
                        {' '}
                    </span>
                    {entityIdPrettyName && (
                        <>
                            {t('on')}
                            {' '}
                            <span className={classes.headerTextStyle}>
                                {entityIdPrettyName}
                            </span>
                        </>
                    )}
                </span>
            );
        case 'issue_status_changed':
        case 'issue_assignee_changed':
            return (
                <span>
                    <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
                        {' '}
                        {t('changed_the')}
                        {' '}
                    </span>
                    <span className={classes.headerTextStyle}>
                        {item === 'issue_status_changed' ? t('Status') : t('Assignee')}
                        {' '}
                    </span>
                    {entityIdPrettyName && (
                        <>
                            {t('of')}
                            {' '}
                            <span className={classes.headerTextStyle}>
                                {entityIdPrettyName}
                            </span>
                        </>
                    )}
                </span>
            );
        case 'issue_created':
            return (
                <span>
                    <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
                        {' '}
                        {t('created the')}
                        {' '}
                    </span>
                    <span className={classes.headerTextStyle}>
                        {t('Incident')}
                        {' '}
                    </span>
                    <span className={classes.headerTextStyle}>{entityIdPrettyName}</span>
                </span>
            );
        case 'issue_assignee_added':
            return (
                <span>
                    <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
                        {' '}
                        {t('New ticket assigned to you')}
                        {' '}
                    </span>
                    <span className={classes.headerTextStyle}>{entityIdPrettyName}</span>
                </span>
            );
        case 'issue_assignee_removed':
            return (
                <span>
                    <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
                        {' '}
                        {t('Your Ticket')}
                        {' '}
                    </span>
                    <span className={classes.headerTextStyle}>{entityIdPrettyName}</span>
                    <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
                        {' '}
                        {t('has been unassigned')}
                    </span>
                </span>
            );
        default:
            return null;
    }
};

interface CreateTitleForNotificationBodyProps {
    item: any;
    ticketName?: string;
    sourceName: string;
    notificationId: string;
    notificationStatus: Record<string, boolean>;
    setNotificationStatus: (status: Record<string, boolean>) => void;
    userId?: string | null;
    organisationId?: string | null;
    userType?: string;
    entityTitle?: string;
}

export const CreateTitleForNotificationBody = (props: CreateTitleForNotificationBodyProps) => {
    const classes = useStyle();
    const {
        item,
        ticketName,
        sourceName,
        notificationId,
        notificationStatus,
        setNotificationStatus,
        userId,
        organisationId,
        userType,
        entityTitle,
    } = props;

    // For worker userType, display entityTitle directly
    if (userType === UserType.WORKER) {
        return (
            <div className={classes.notificationBodyTitle}>
                <div>
                    <span className={classes.headerTextStyle}>{entityTitle}</span>
                </div>
                {!isMobile && (
                    <TimeAndBadgeComponent
                        item={item}
                        notificationId={notificationId}
                        notificationStatus={notificationStatus}
                        setNotificationStatus={setNotificationStatus}
                        userId={userId}
                        organisationId={organisationId}
                    />
                )}
            </div>
        );
    }

    return (
        <div className={classes.notificationBodyTitle}>
            <div>
                <span className={classes.userName}>{item.actionUser?.userName}</span>
                <CreateHeaderForNotificationBody
                    item={eventTypes?.[sourceName]?.[item?.eventType]}
                    entityIdPrettyName={ticketName}
                    classes={classes}
                    sourceName={sourceName}
                />
            </div>
            {!isMobile && (
                <TimeAndBadgeComponent
                    item={item}
                    notificationId={notificationId}
                    notificationStatus={notificationStatus}
                    setNotificationStatus={setNotificationStatus}
                    userId={userId}
                    organisationId={organisationId}
                />
            )}
        </div>
    );
};
